import React from 'react'
import { Container } from 'react-bootstrap'

const Credits = () => {
  return <Container fluid className='bg-light'>
    <h1>Credits</h1>    
    <ul>
      <li>Realizzato da G&F Software S.r.l<br />via del fontanile arenato 171b 00163 Roma</li>
      <li><>Image by <a target="_blank" rel='noreferrer' href="https://www.freepik.com/free-vector/online-medical-conference-with-doctors_13108104.htm#query=doctors%20pc&position=0&from_view=search&track=ais&uuid=fd1e1a29-085e-481f-b8f2-e2bbc87973c2">Freepik</a></></li>
      <li><a target="_blank" rel='noreferrer' href="https://www.flaticon.com/free-icons/trauma" title="trauma icons">Trauma icons created by Dewi Sari - Flaticon</a></li>
    </ul>        
  </Container>
}

export default Credits